module.exports = __webpack_public_path__ + "孙畅-a8548276.png";